import { render } from "./Team.vue?vue&type=template&id=baedac9a"
import script from "./Team.vue?vue&type=script&lang=ts"
export * from "./Team.vue?vue&type=script&lang=ts"
script.render = render

export default script